// Libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Models
import { gradeClass, Campus, CampusFullItem, 
        Schoolyear, YearGroup, Semester, Term, Period } from '../models/Catalog';
// Services
import { ApiService} from './ApiService';
import { SettingService } from './SettingService';
import { FileService } from './FileService';

@Injectable()

export class CatalogService {
    private fullCampusUrl = '/included-campuses';
    private campusUrl = '/campuses';
    private homeroomUrl = '/homerooms';
    private schoolyearUrl = '/school-years';
    private yearGroupUrl = '/yearGroups';
    private yearLevelUrl = '/year-levels';
    private semesterUrl = '/semesters';
    private gradeClassUrl = '/gradeClasses';
    private termUrl = '/terms';
    private periodUrl = '/asa-periods';
    private apiUrl = '';

    constructor(
        private apiService: ApiService,
        private settingService: SettingService,
        private fileService: FileService
    ) {
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }

    /**
     * Get campus items
     * @returns {Observable<Campus[]>} Array list of Campus class
     */
    getCampuses(): Observable<Campus[]> {
        const requestUrl = this.apiUrl + this.campusUrl;
        
        return this.apiService.get<Campus[]>(requestUrl);
    }
    
    /**
     * Get full campus item with contain yearlevels and homerooms.
     * @returns {Observable<CampusFullItem[]>} Array list of CampusFullItem class
     */
    getCampusesFullItems(): Observable<CampusFullItem[]> {
        const requestUrl = this.apiUrl + this.fullCampusUrl;

        return this.apiService.get<CampusFullItem[]>(requestUrl);
    }

    /**
     * Get homerooms
     * @returns {Observable<gradeClass[]>} Array list of gradeClass class
     */
    getHomerooms(): Observable<gradeClass[]> {
        const requestUrl =  this.apiUrl + this.homeroomUrl;
        
        return this.apiService.get<gradeClass[]>(requestUrl);
    }

    /**
     * Get school years
     * @returns {Observable<Schoolyear[]>} Array list of Schoolyear class
     */
    getSchoolyears(): Observable<Schoolyear[]> {
        const requestUrl =  this.apiUrl + this.schoolyearUrl;
        
        return this.apiService.get<Schoolyear[]>(requestUrl);
    }

    /**
     * Get year levels
     * @returns {Observable<YearGroup[]>} Array list of YearGroup class
     */
    getYearLevels(): Observable<YearGroup[]> {
        const requestUrl =  this.apiUrl + this.yearLevelUrl;
        
        return this.apiService.get<YearGroup[]>(requestUrl);
    }

    getSemesters(): Observable<Semester[] > {
        const requestUrl = this.apiUrl + this.semesterUrl;

        return this.apiService.get<Semester[]>(requestUrl);
    }
    
    /**
     * Handle Promise errors
     * @returns {String} Message error
     */
    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }

    /**
     * Get Year Groups
     * @returns {Observable<YearGroup[]>} Array list of YearGroup class
     */
     getYearGroups(): Observable<YearGroup[]> {
        const requestUrl =  this.apiUrl + this.yearGroupUrl;
        
        return this.apiService.get<YearGroup[]>(requestUrl);
    }

    getTerms(): Observable<Term[] > {
        const requestUrl = this.apiUrl + this.termUrl;

        return this.apiService.get<Term[]>(requestUrl);
    }

    /**
     * Get grade_classes
     * @returns {Observable<gradeClass[]>} Array list of gradeClass class
     */
     getGradeClasses(): Observable<gradeClass[]> {
        const requestUrl =  this.apiUrl + this.gradeClassUrl;
        
        return this.apiService.get<gradeClass[]>(requestUrl);
    }

    getPeriodByTermId(termId: any): Observable<Period[]> {
        const requestUrl = this.apiUrl  + this.periodUrl + '?term_id=' + termId;

        return this.apiService.get<Period[]>(requestUrl);
    }

    gePeriodByCurrentTerm(): Observable<Period[]> {
        return this.getTerms()
            .map(termList => _.filter(termList, function(o) { return o.is_current; })[0].id)
            .switchMap(currentTermId => currentTermId ? this.getPeriodByTermId(currentTermId) : Observable.of(null));
    }

    getPeriods(): Observable<Period[] > {
        const requestUrl = this.apiUrl + this.periodUrl;

        return this.apiService.get<Period[]>(requestUrl);
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/core/services/CatalogService.ts